import { isPlatformBrowser } from '@angular/common';
import { Directive, ElementRef, AfterViewInit, NgZone, Inject, PLATFORM_ID } from '@angular/core';
// import * as $ from 'jquery';

@Directive({
  selector: '[appBsDropdownStatus]',
  exportAs: 'bsDpStatus'
})
export class BsDropdownStatusDirective implements AfterViewInit {
  isOpen = false;

  constructor(
    private el: ElementRef,
    private zone: NgZone,
    @Inject(PLATFORM_ID) private platformId: object,
  ) { }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      $(this.el.nativeElement).on('show.bs.dropdown', () => {
        this.zone.run(() => {
          this.isOpen = true;
        });
      });

      $(this.el.nativeElement).on('hidden.bs.dropdown', () => {
        this.zone.run(() => {
          this.isOpen = false;
        });
      });
    }
  }
}
